import { render, staticRenderFns } from "./question_teamplate.vue?vue&type=template&id=3f38fe64&scoped=true&"
import script from "./question_teamplate.vue?vue&type=script&lang=js&"
export * from "./question_teamplate.vue?vue&type=script&lang=js&"
import style0 from "./question_teamplate.vue?vue&type=style&index=0&id=3f38fe64&prod&scoped=true&lang=scss&"
import style1 from "./question_teamplate.vue?vue&type=style&index=1&id=3f38fe64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38fe64",
  null
  
)

export default component.exports